export const sortNumbersString = (a: string, b: string): number => {
  return Number.parseInt(a) - Number.parseInt(b)
}
